import axios from "axios";
import {
  USER_CURRENT_URL,
  USER_READ_URL,
  USER_FIND_URL,
  MEMBERS_LIST_URL,
  RATING_URL,
  STATISTIC_URL,
  USER_SLA_URL,
} from "../config/apiConstants";
import { prepareRequestparams } from "../helpers/requestHelpders";

export async function getCurrentUser() {
  return await axios.get(USER_CURRENT_URL, {
    params: { include: "user_permissions" },
  });
}
export async function getMembers() {
  return await axios.get(MEMBERS_LIST_URL, {
    params: { filter: { is_asana_team_user: true } },
  });
}
export async function getRating(sort = "-taken") {
  return await axios.get(RATING_URL, prepareRequestparams(sort));
}
export async function getStatistic(withCalendar) {
  return await axios.get(STATISTIC_URL, {
    params: { withCalendar: !!withCalendar ? 1 : 0 },
  });
}
export async function getUserSlaStatistic(params) {
  return await axios.get(USER_SLA_URL, {
    params: params,
  });
}
export async function getUsers(sort, filter, page, include) {
  return await axios.get(
    USER_READ_URL,
    prepareRequestparams(sort, filter, page, include),
  );
}
export async function findUsers(searchPhrase, sort, page, include) {
  return await axios.get(
    USER_FIND_URL,
    prepareRequestparams(sort, { search: searchPhrase }, page, include),
  );
}
